import { compose } from "redux";
import classNames from "classnames";
import { Grid } from "@material-ui/core";
import React, { PureComponent } from "react";
import { withStyles } from "@material-ui/core/styles";
import { green, red } from "@material-ui/core/colors";

class Row extends PureComponent {
  render() {
    const { classes, isOver, canDrop, children, ...rest } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        className={classNames(classes.root, {
          [classes.canDrop]: isOver && canDrop,
          [classes.canNotDrop]: isOver && !canDrop,
        })}
        {...rest}
      >
        {children}
      </Grid>
    );
  }
}

const styles = theme => ({
  root: {
    height: theme.spacing(3),
    background: theme.palette.common.white,
    borderBottom: `1px solid ${theme.altus.background.view}`,
  },
  canDrop: {
    background: green[100],
  },
  canNotDrop: {
    background: red[100],
  },
});

export default compose(withStyles(styles))(Row);
